import type { PropsWithChildren, ReactNode } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/Button"
import { join } from "@/utils/join"

export interface OverlayProps {
  tradeId?: number
  base: string
  terms: string
  onClose?: () => void
  className?: string
}

const OverlayHeader = ({
  base,
  terms,
  tradeId,
  Icon,
}: {
  base: string
  terms: string
  Icon: ReactNode
  tradeId?: number
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex w-full items-center gap-sm bg-tertiary px-md py-xs">
      {Icon}
      <p className="text-sm-medium text-tertiary">{`${base}/${terms}`}</p>
      {tradeId && (
        <p className="ml-auto text-sm-medium text-tertiary uppercase">
          {t("trade.id")}: <span data-testid="trade-id">{tradeId}</span>
        </p>
      )}
    </div>
  )
}

export const OverlayBase = ({
  children,
  base,
  terms,
  tradeId,
  onClose,
  Icon,
  className,
  ...props
}: PropsWithChildren<OverlayProps & { Icon: ReactNode }>) => {
  const { t } = useTranslation()
  return (
    <div
      className={join(
        className ?? "",
        "flex h-full w-full flex-col items-center pb-sm",
      )}
      {...props}
    >
      <OverlayHeader base={base} terms={terms} tradeId={tradeId} Icon={Icon} />
      {children}
      {onClose && (
        <Button variant="primary" size="sm" onClick={onClose}>
          {t("close")}
        </Button>
      )}
    </div>
  )
}
